import MaskInput from 'react-maskinput'

const CartFieldText = (props) => {
  if (props.name == 'phone') {
    return <MaskInput
      alwaysShowMask
      mask={'+0 000 000 00 00'}
      size={20}
      showMask
      maskChar="_"
      value={props.value}
      onChange={(e) => props.handleChange(e)}
      onBlur={(e) => props.validateField(e.target.name, e.target.value)}
      name={props.name}
      placeholder={props.placeholder}
      type="text"
      className={`af-class-cart__user-field w-input${props.isValid === false ? ' user-input-invalid' : ''}`}
    />
  } else {
    return <input
      value={props.value}
      onChange={(e) => props.handleChange(e)}
      onBlur={(e) => props.validateField(e.target.name, e.target.value)}
      name={props.name}
      placeholder={props.placeholder}
      type="text"
      className={`af-class-cart__user-field w-input${props.isValid === false ? ' user-input-invalid' : ''}`}
      maxLength={256}
    />
  }
}

export default CartFieldText